module.exports = __webpack_public_path__ + "static/media/Line chart.77fb5c78.svg";